import { render, staticRenderFns } from "./viewMoreDetails.component.vue?vue&type=template&id=4d4b2417&scoped=true&"
import script from "./viewMoreDetails.component.vue?vue&type=script&lang=tsx&"
export * from "./viewMoreDetails.component.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4b2417",
  null
  
)

export default component.exports